export type LaneMotion = {
  lanePosition: number;
  steeringYaw: number;
};

export function clampUnit(value: number): number {
  return Math.max(0, Math.min(1, value));
}

export function smoothstep(value: number): number {
  const progress = clampUnit(value);
  return progress * progress * progress * (progress * (progress * 6 - 15) + 10);
}

export function laneMotion(
  fromLane: number,
  toLane: number,
  progress: number,
): LaneMotion {
  const clamped = clampUnit(progress);
  const direction = Math.sign(toLane - fromLane);
  return {
    lanePosition: fromLane + (toLane - fromLane) * smoothstep(clamped),
    steeringYaw: direction * Math.sin(clamped * Math.PI) * 0.065,
  };
}

export function projectedRoadProgress(progress: number): number {
  const clamped = clampUnit(progress);
  return clamped * clamped;
}

export function remotePresenceAgeSeconds(
  nowEpochMilliseconds: number,
  receivedAtEpochMilliseconds: number,
): number {
  return Math.min(
    60,
    Math.max(0, (nowEpochMilliseconds - receivedAtEpochMilliseconds) / 1_000),
  );
}

export function advanceWrappedProgress(
  progress: number,
  velocityPerSecond: number,
  deltaSeconds: number,
): number {
  const next =
    progress + Math.max(0, velocityPerSecond) * Math.max(0, deltaSeconds);
  if (next <= 1.02) return next;
  return 0.08 + ((next - 1.02) % 0.94);
}
